import { render, staticRenderFns } from "./AboutTab2.vue?vue&type=template&id=77bf11e8&"
import script from "./AboutTab2.vue?vue&type=script&lang=js&"
export * from "./AboutTab2.vue?vue&type=script&lang=js&"
import style0 from "./AboutTab2.vue?vue&type=style&index=0&id=77bf11e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports